import $ from 'jquery';
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class Animation {
    constructor(props) {
        this.bgElement = this.getAnimateEl('intro-bg');
        this.headerEl = this.getAnimateEl('header');
        this.headerAlreadyAnimated = false;
        this.animationShift = props?.animationShift || 100;
        this.introTimeline = gsap.timeline();

        this.checkScrollHeaderAnimate();

        this.bgElement.on('load', () => {
            this.handleBgLoaded();
        }).each(function() {
            if (this.complete) $(this).trigger('load');
        });
    }

    getAnimateEl = name => $(`[data-animation-target="${name}"]`);

    getSection = name => $(`[data-animation-section="${name}"]`);

    checkScrollHeaderAnimate = () => {
        if ((window.scrollY > this.bgElement.outerHeight() && !this.headerAlreadyAnimated) || !this.bgElement.length) {
            gsap.fromTo(this.headerEl, {
                yPercent: -this.animationShift,
                autoAlpha: 0
            }, {
                yPercent: 0,
                autoAlpha: 1
            })
            
            this.headerAlreadyAnimated = true
        }
    };

    handleBgLoaded = () => {
        this.introTimeline
            .to(this.bgElement, {autoAlpha: 1})
            .addLabel('header-in')
            .fromTo(this.getAnimateEl('intro-logo'), {
                autoAlpha: 0,
                scale: 0
            }, {
                autoAlpha: 1,
                scale: 1,
                transformOrigin: 'center center',
                ease: 'bounce',
                duration: 1
            })
            .fromTo(this.getAnimateEl('title'), {
                autoAlpha: 0,
                x: this.animationShift
            }, {
                autoAlpha: 1,
                x: 0,
                ease: 'power2.out',
                stagger: .25
            })
            .fromTo(this.getAnimateEl('subtitle'), {
                autoAlpha: 0,
                x: this.animationShift
            }, {
                autoAlpha: 1,
                x: 0,
                ease: 'power1.out',
                duration: 1
            })
        ;

        if (!this.headerAlreadyAnimated) {
            this.introTimeline.add(gsap.fromTo(this.headerEl, {
                yPercent: -this.animationShift,
                autoAlpha: 0
            }, {
                yPercent: 0,
                autoAlpha: 1
            }), 'header-in');
            
            this.headerAlreadyAnimated = true
        }
    };

    animimateBox = box => {
        gsap.timeline({
            scrollTrigger: {
                trigger: box,
                start: '0 85%',
                markers: false
            }
        })
            .fromTo(box, {
                autoAlpha: 0,
                y: this.animationShift
            }, {
                autoAlpha: 1,
                y: 0
            })
    };

    animateCarouselSection = (sectionName) => {
        const section = this.getSection(sectionName);

        gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: '20% 90%',
                markers: false
            }
        })
        .fromTo(section, {autoAlpha: 0}, {autoAlpha: 1})
        .fromTo(this.getAnimateEl(sectionName+'-title'), {
            autoAlpha: 0,
            x: this.animationShift
        }, {
            autoAlpha: 1,
            x: 0,
        })
        .fromTo(this.getAnimateEl(sectionName+'-slide'), {
            autoAlpha: 0,
            x: this.animationShift
        }, {
            autoAlpha: 1,
            x: 0,
            ease: 'bounce',
            duration: 1.5,
            stagger: .1,
            onComplete: () => section.addClass('is-animated')
        })
        .fromTo(this.getAnimateEl(sectionName+'-controls'), {
            y: 20,
            autoAlpha: 0
        }, {
            y: 0,
            autoAlpha: 1
        });
    };

    init() {
        this.getAnimateEl('intro-box').each((_, box) => this.animimateBox(box))
        //INTRO END

        this.animateCarouselSection('partners');
        // PARTNERS END

        this.animateCarouselSection('media');
        // media END

        this.getAnimateEl('clubs-box').each((_, box) => this.animimateBox(box))
        // CLUBS END

        const tasksHeadSection = this.getSection('tasks-head');
        const tasksBodySection = this.getSection('tasks-body')
        gsap.timeline({
            scrollTrigger: {
                trigger: tasksHeadSection,
                start: '0 75%',
                markers: false
            }
        })
            .fromTo(this.getAnimateEl('tasks-head-title'), {
                autoAlpha: 0,
                x: this.animationShift
            }, {
                autoAlpha: 1,
                x: 0,
                stagger: .2
            });

        gsap.timeline({
            scrollTrigger: {
                trigger: tasksBodySection,
                start: '0 75%',
                markers: false
            }
        })
            .fromTo(this.getAnimateEl('tasks-body-item'), {
                autoAlpha: 0,
                x: this.animationShift 
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 1.5,
                stagger: .25,
                ease: 'bounce'
            })
            .fromTo(this.getAnimateEl('tasks-body-controls'), {
                autoAlpha: 0,
                x: this.animationShift 
            }, {
                autoAlpha: 1,
                x: 0,
            })
        // TASKS END

        const achievementsSection = this.getSection('achievements');
        gsap.timeline({
            scrollTrigger: {
                trigger: achievementsSection,
                start: '0 75%',
                markers: false
            }
        })
        .fromTo(this.getAnimateEl('achievements-title'), {
            autoAlpha: 0,
            x: this.animationShift 
        }, {
            autoAlpha: 1,
            x: 0
        })
        .fromTo(this.getAnimateEl('achievements-slide'), {
            autoAlpha: 0,
            x: this.animationShift
        }, {
            autoAlpha: 1,
            x: 0,
            ease: 'bounce',
            duration: 1.5,
            stagger: .1,
        })
        // ACHIEVEMENTS END

        this.getAnimateEl('numbers-item').each((_, box) => this.animimateBox(box))
        // NUMBERS END
        
        const feedbackSection = this.getSection('feedback');
        gsap.timeline({
            scrollTrigger: {
                trigger: feedbackSection,
                start: '0 75%',
                markers: false
            }
        })
            .fromTo(this.getAnimateEl('feedback-title'), {
                autoAlpha: 0,
                y: this.animationShift 
            }, {
                autoAlpha: 1,
                y: 0
            })
            .fromTo(this.getAnimateEl('feedback-element-left'), {
                autoAlpha: 0,
                x: -this.animationShift 
            }, {
                autoAlpha: 1,
                x: 0,
                stagger: .1
            }, 'fields-arrival')
            .fromTo(this.getAnimateEl('feedback-element-right'), {
                autoAlpha: 0,
                x: this.animationShift 
            }, {
                autoAlpha: 1,
                x: 0,
                stagger: .1
            }, 'fields-arrival')
        //FEEDBACK END

        const footerSection = this.getSection('footer');
        gsap.timeline({
            scrollTrigger: {
                trigger: footerSection,
                start: '0 80%',
                markers: false
            }
        })
            .fromTo(this.getAnimateEl('footer-element'), {
                autoAlpha: 0,
                y: this.animationShift 
            }, {
                autoAlpha: 1,
                y: 0,
                stagger: .25,
            })
        //FOOTER END
    };
}